// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Trek Universe - Main Export
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { StarTrekAliensPlanets } from './AliensConfig';

export const universeStarTrek = {
  id: 'startrek',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: StarTrekAliensPlanets
};

export default universeStarTrek;
